

/// <reference path="AccountBalance.ts" />

// Generated class ClientLoyaltyBalance_ManagedObject

class ClientLoyaltyBalance_ManagedObject extends AccountBalance
{
}
